import React, { useState, useEffect } from 'react';
import SEO from '../../components/common/SEO';
import Header from '../../components/common/Header';
import Hero from '../../components/sections/Hero';
import ChecklistSection from '../../components/sections/ChecklistSection';
import AboutSection from '../../components/sections/AboutSection';
import FeaturesSection from '../../components/sections/FeaturesSection';
import TestimonialsSection from '../../components/sections/TestimonialsSection';
import ContactSection from '../../components/sections/ContactSection';
import Footer from '../../components/common/Footer';
import ContactModal from '../../components/common/ContactModal';
import BottomContactBar from '../../components/common/BottomContactBar';
import './HomePage.css';

const HomePage = () => {
  const [showContactModal, setShowContactModal] = useState(false);

  const handleOpenContactModal = () => {
    setShowContactModal(true);
    document.body.classList.add('modal-open');
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
    document.body.classList.remove('modal-open');
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  return (
    <>
      {/* SEO Meta Tags */}
      <SEO
        title="Informezz - Sistema de Gestão Completo para Lojas de Moda"
        description="Sistema ERP completo para lojas de roupas, calçados e acessórios. Gestão de condicionais, PDV, estoque, financeiro, e-commerce e mais. Mais de 20 anos de experiência no varejo de moda."
        keywords="sistema gestão loja moda, erp varejo roupas, software loja calçados, gestão condicionais, pdv loja roupas, sistema venda roupas, erp nuvem moda, software varejo moda, gestão estoque roupas, sistema financeiro loja, live shop, inteligência artificial vendas"
      />

      {/* Header */}
      <Header onContactClick={handleOpenContactModal} />

      {/* Main Content */}
      <main className="homepage">
        {/* Hero Section */}
        <Hero onContactClick={handleOpenContactModal} />

        {/* Checklist Section */}
        <ChecklistSection />

        {/* About Section */}
        <AboutSection />

        {/* Features Section */}
        <FeaturesSection onContactClick={handleOpenContactModal} />

        {/* Testimonials Section */}
        <TestimonialsSection />

        {/* Contact Section */}
        <ContactSection onContactClick={handleOpenContactModal} />
      </main>

      {/* Footer */}
      <Footer />

      {/* Bottom Contact Bar */}
      <BottomContactBar onContactClick={handleOpenContactModal} />

      {/* Contact Modal */}
      <ContactModal 
        show={showContactModal} 
        onClose={handleCloseContactModal} 
      />
    </>
  );
};

export default HomePage;
